import { inject, injectable } from "inversify";
import { DocumentTypeModel, ICPLDocumentTypesClient } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IDocumentTypesService {
  getDocumentTypes(includeHidden: boolean): Promise<DocumentTypeModel[]>;
}

@injectable()
export class DocumentTypesService implements IDocumentTypesService {
  @inject(SERVICE_TYPES.CPLDocumentTypesClient) cplDocumentTypesClient!: ICPLDocumentTypesClient;

  async getDocumentTypes(includeHidden: boolean): Promise<DocumentTypeModel[]> {
    return this.cplDocumentTypesClient.getDocumentTypes(includeHidden);
  }
}
